import React, { Component } from "react";
import { Icon, Layout, Menu } from "antd";
import { NavLink } from "react-router-dom";
import logo from "../../../assets/images/vaf.png";
const { Sider } = Layout;
const { SubMenu } = Menu;

class SiderTemplate extends Component {
  activeKey(pathname) {
    switch (pathname) {
      case "/users":
      case "/admins":
      case "/registers":
        return ["sub1"];

      case "/categories":
      case "/authors":
      case "/speakers":
      case "/sponsors":
        return ["sub2"];

      case "/books":
      case "/chapters":
        return ["sub3"];
    }
  }
  render() {
    console.log(this.props);
    return (
      <Sider>
        <div className="logo">
          <img src={logo} width="100%"></img>
        </div>

        <Menu
          theme="dark"
          defaultSelectedKeys={this.props.history.location.pathname}
          mode="inline"
          defaultOpenKeys={this.activeKey(this.props.history.location.pathname)}
        >
          <SubMenu
            key="sub1"
            title={
              <span>
                <Icon type="user" />
                <span>Quản lý tài khoản</span>
              </span>
            }
          >
            {/* <Menu.Item key="/users">
                            <NavLink to={"/users"}> Quản lý người dùng </NavLink>
                        </Menu.Item> */}
            <Menu.Item key="/admins">
              <NavLink to={"/admins"}>Quản lý tài khoản</NavLink>
            </Menu.Item>
            <Menu.Item key="/registers">
              <NavLink to={"/registers"}>Phê duyệt thành viên</NavLink>
            </Menu.Item>
            <Menu.Item key="/users">
              <NavLink to={"/users"}>Quản lý hội viên</NavLink>
            </Menu.Item>
          </SubMenu>
          <SubMenu
            key="sub2"
            title={
              <span>
                <Icon type="team" />
                <span>Quản lý danh mục</span>
              </span>
            }
          >
            <Menu.Item key="/categories">
              <NavLink to={"/categories"}>Thể loại</NavLink>
            </Menu.Item>
            <Menu.Item key="/authors">
              <NavLink to={"/authors"}>Tác giả</NavLink>
            </Menu.Item>
            <Menu.Item key="/speakers">
              <NavLink to={"/speakers"}>Người đọc </NavLink>
            </Menu.Item>
            <Menu.Item key="/sponsors">
              <NavLink to={"/sponsors"}>Nhà tài trợ </NavLink>
            </Menu.Item>
          </SubMenu>
          <SubMenu
            key="sub3"
            title={
              <span>
                <Icon type="team" />
                <span>Quản lý sách nói</span>
              </span>
            }
          >
            <Menu.Item key="/books">
              <NavLink to={"/books"}>Thông tin sách</NavLink>
            </Menu.Item>
            <Menu.Item key="/chapters">
              <NavLink to={"/chapters"}> Tạo mục lục</NavLink>
            </Menu.Item>
          </SubMenu>
          {/* <SubMenu key="sub4"
                             title={<span><Icon type="team"/><span>Thông tin</span></span>}>
                        <Menu.Item key="9">Người dùng</Menu.Item>
                        <Menu.Item key="10">Hệ thống</Menu.Item>
                        <Menu.Item key="11">Dự án</Menu.Item>
                    </SubMenu>*/}
          <Menu.Item key="12">
            <NavLink to={"/login"}>Đăng xuất</NavLink>
          </Menu.Item>
        </Menu>
      </Sider>
    );
  }
}

export default SiderTemplate;
